<div class="container">
  <app-logo
    class="container__logo"
    (click)="router.navigate(['/'])"
  ></app-logo>
</div>
